import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import { visibleRoutes } from "../../../app/routes/manifest";
import type { Role } from "../../../app/session/SessionProvider";

export function Sidebar({ role }: { role: Role }) {
  const [expanded, setExpanded] = useState(true);
  const items = visibleRoutes(role).filter((route) => route.sidebar).sort((a, b) => (a.sidebar?.order ?? 0) - (b.sidebar?.order ?? 0));
  return (
    <nav id="icat-sidebar" className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${expanded ? "" : "toggled"}`} aria-label="主要導覽">
      <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/"><span className="sidebar-brand-text mx-3">ICAT</span></Link>
      <hr className="sidebar-divider" />
      {items.map((route) => (
        <div key={route.id} className="nav-item">
          <NavLink className={({ isActive }) => `nav-link${isActive ? " active" : ""}`} to={route.path} end={route.path === "/"}>
            <span>{route.title}</span>
          </NavLink>
        </div>
      ))}
      <div className="text-center d-none d-md-inline">
        <button id="sidebarToggle" type="button" className="rounded-circle border-0" aria-controls="icat-sidebar" aria-expanded={expanded} onClick={() => setExpanded((value) => !value)}>
          <svg className="icat-sidebar-toggle-icon" aria-hidden="true" viewBox="0 0 24 24">
            <path d="m15 18-6-6 6-6" />
          </svg>
          <span className="sr-only">{expanded ? "收合側邊欄" : "展開側邊欄"}</span>
        </button>
      </div>
    </nav>
  );
}

